import { dayjs } from "@outschool/time";

// How many days after the section ended a user can still provide feedback
export const REVIEWS_TIME_LIMIT_IN_DAYS = 30;

// How many days after the feedback was created it can be deleted
export const DELETE_TIME_LIMIT_IN_DAYS = 30;

// How many days after the feedback was created a user can still respond
export const RESPONSE_TIME_LIMIT_IN_DAYS = 30;

// On ongoing classes, edits are locked this many days after the review was submitted
export const REVIEW_EDIT_LOCK_DAYS_FOR_ONGOING_CLASSES = 30;

export const isInResponseTimeWindow = (review: { created_at: Date | null }) => {
  if (review.created_at == null) {
    return false;
  }
  return dayjs(review.created_at)
    .add(RESPONSE_TIME_LIMIT_IN_DAYS, "days")
    .isAfter();
};

export const isInDeleteTimeWindow = (review: { created_at: Date }) => {
  return dayjs().diff(review.created_at, "days") < DELETE_TIME_LIMIT_IN_DAYS;
};

/**
 * For ongoing classes, edits are only allowed 30 days after the review was submitted
 */
export const isWithinEditWindowForOngoingClass = (review: {
  created_at: Date | null;
}) => {
  if (review.created_at == null) {
    return false;
  }
  return (
    dayjs().diff(dayjs(review.created_at), "days") <
    REVIEW_EDIT_LOCK_DAYS_FOR_ONGOING_CLASSES
  );
};
